import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title @model.friendlyUrl}}\n\n{{outlet}}")